import { Component, Input } from '@angular/core';

@Component({
	selector: 'material-loader',
	template: require('./material-loader.component.html'),
	styles: [':host {width: 100%}']
})
export class MaterialLoaderComponent {
	@Input()
	public loading: number = 1;
}
